<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- C400系共通部品_Steps -->
    <app-c400-steps></app-c400-steps>

    <div class="information-margin"></div>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle" style="font-size: 6rem"></i><br />
        </div>
        <div class="message-margin"></div>
        <!-- 提案の場合 -->
        <div class="p-d-flex p-jc-center" *ngIf="'suggest' == this.suggestOrRequest">提案を受理しました</div>
        <!-- 提案の場合 -->
        <div class="p-d-flex p-jc-center" *ngIf="'request' == this.suggestOrRequest">依頼を受理しました</div>
      </div>
    </div>

    <!-- 本文 -->
    <!----------------------提案の場合--------------------------->
    <div *ngIf="'suggest' == this.suggestOrRequest">
      <p class="p-d-flex p-jc-center font-color">
        提案内容は運営事務局で審査・承認後、課題登録団体へ送付されます。
      </p>
      <p class="p-d-flex p-jc-center font-color">
        内容に不明点等がある場合は、運営事務局よりご連絡します。審査結果はメールにて通知します。
      </p>
    </div>
    <!----------------------依頼の場合--------------------------->
    <div *ngIf="'request' == this.suggestOrRequest">
      <p class="p-d-flex p-jc-center font-color">
        依頼内容は運営事務局で審査・承認後、ソリューション登録団体へ送付されます。
      </p>
      <p class="p-d-flex p-jc-center font-color">
        内容に不明点等がある場合は、運営事務局よりご連絡します。審査結果はメールにて通知します。
      </p>
      <p class="p-d-flex p-jc-center guard-text">
        依頼への回答は、各会員の任意によるものです。<br />
        運営事務局から各会員へ回答の催促等に関する連絡はできかねますのでご了承ください。
      </p>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        label="マイページへ戻る"
        class="button-default-size button1"
        (click)="moveB301()"
      ></button>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
